import {AfterViewInit, Component, EventEmitter, Input, OnDestroy, OnInit, Output, ChangeDetectionStrategy, ChangeDetectorRef, OnChanges, SimpleChanges} from '@angular/core';
import {AbstractControl, FormGroup, FormControl, Validators} from "@angular/forms";
import {debounceTime, distinctUntilChanged, Observable, Subject, takeUntil} from "rxjs";
import {tap} from "rxjs/operators";

@Component({
  selector: 'app-form-input-text',
  templateUrl: './form-input-text.component.html',
  styleUrls: ['./form-input-text.component.sass']
  // Temporarily removed OnPush to fix cursor disappearing issue
  // changeDetection: ChangeDetectionStrategy.OnPush
})
export class FormInputTextComponent implements OnInit, AfterViewInit, OnDestroy, OnChanges {

  @Input() type: string | undefined = '';
  @Input() placeholder: string | undefined = '';
  @Input() required: boolean = false;
  @Input() label: string | undefined = '';
  @Input() validation: string | undefined = '';
  @Input() valid = false;
  @Input() name!: string;
  @Input() maxLength: string | number | undefined;
  @Input() minlength: number | undefined = undefined;
  @Input() error? = false;
  @Input() errorMessage? = '';
  @Input() cssClasses? = '';
  @Input() toolTipMessage: string = '';
  @Input() htmlId: number = Math.floor(Math.random() * (1 + Math.random() * 1000));
  @Input() isPhoneNumber: boolean = false;
  @Input() autocomplete: string = 'off';
  @Input() readonly: boolean = false;

  @Input() formName!: FormGroup;
  @Input() control!: FormControl;

  @Output() onValueChanged = new EventEmitter();
  @Output() onKeyDownEnter = new EventEmitter();

  public inputValue = '';
  public ngUnsubscribe = new Subject<void>();
  textInputValueChanges: Observable<string> = new Observable<string>();
  private inputChange$ = new Subject<void>();
  private destroy$ = new Subject<void>();
  public showValidation = false;
  public isNextRequired = false;
  private nextControl: FormControl | null = null;

  constructor(private cdr: ChangeDetectorRef) {}

  ngOnInit(): void {
    if (this.control) {
      // Subscribe to status changes
      this.control.statusChanges
        .pipe(takeUntil(this.destroy$))
        .subscribe(() => {
          // Use setTimeout to defer the update and prevent ExpressionChangedAfterItHasBeenCheckedError
          setTimeout(() => {
            this.showValidation = this.control.touched;
            this.cdr.markForCheck();
          });
        });

      // Subscribe to value changes with debounce to avoid showing errors while typing
      this.control.valueChanges
        .pipe(
          debounceTime(500), // Increased debounce time for better UX
          distinctUntilChanged(),
          takeUntil(this.destroy$)
        )
        .subscribe(() => {
          this.onValueChanged.emit(true);
        });
    }

    // Reset next state when any control value changes
    if (this.formName) {
      Object.values(this.formName.controls).forEach(control => {
        control.valueChanges
          .pipe(takeUntil(this.destroy$))
          .subscribe(() => {
            if (control === this.nextControl) {
              this.isNextRequired = false;
              this.nextControl = null;
            }
          });
      });
    }
  }

  ngAfterViewInit() {
    // Ensure form and control exist before subscribing
    if (this.formName && this.formName.controls[this.name]) {
      this.textInputValueChanges = this.formName.controls[this.name].valueChanges.pipe(
        debounceTime(300), // Wait 300ms after value changes
        distinctUntilChanged(),
        takeUntil(this.ngUnsubscribe)
      );

      this.textInputValueChanges.subscribe((val: string) => {
        this.onValueChanged.emit(true);
      });
    }
  }

  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
    this.destroy$.next();
    this.destroy$.complete();
  }

  onBlur() {
    // if (this.control) {
    //   this.showValidation = true;
    //   this.control.markAsTouched();
    //   this.control.updateValueAndValidity();
    //   this.cdr.markForCheck();
    // }
  }

  onKeyDown(event: KeyboardEvent) {
    if (event.key === 'Enter') {
      this.onKeyDownEnter.emit();
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    // Handle any input changes if needed
  }
}
